import React, { Component } from 'react';
import { Modal } from 'semantic-ui-react';
import { observer, inject } from 'mobx-react';
import { withTranslation } from 'react-i18next';
import api from '../../api';
import Loader from '../Loader/Loader';
import WithRouter from '../Extensions/WithRouter';

class ChangePasswordModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenMCP: props.isOpenMCP,
      isExpirationPass: props.isExpirationPass || null,
      //isLoading: false,
      modalAlert: false,
      isLoader: false,
      //isValidfield: false,
      isAutoCompleteCurrentPass: false,
      isAutoCompleteNewPass: false,
      isAutoCompleteConfirmPass: false,
      modalAlertMsg: '',
      modalAlertTitle: '',
      currentPassword: '',
      newPassword: '',
      newPasswordConfirmation: '',
      currentPasswordError: '',
      newPasswordError: '',
      newPasswordConfirmationError: '',
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.handleCurrentPassword = this.handleCurrentPassword.bind(this);
    this.handleCurrentFocus = this.handleCurrentFocus.bind(this);
    this.handleNewFocus = this.handleNewFocus.bind(this);
    this.handleConfirmFocus = this.handleConfirmFocus.bind(this);
    this.handleNewPassword = this.handleNewPassword.bind(this);
    this.handleNewPasswordConfirmation = this.handleNewPasswordConfirmation.bind(this);
    this.handleConfirm = this.handleConfirm.bind(this);
    this.handleCloseAlert = this.handleCloseAlert.bind(this);
    this.closePasswordModal = this.closePasswordModal.bind(this);
  }

  componentDidMount() {}

  componentDidUpdate(prevProps) {
    const { isOpenMCP } = this.props;

    if (prevProps.isOpenMCP !== isOpenMCP) {
      this.setState({
        isOpenMCP,
        currentPassword: '',
        newPassword: '',
        newPasswordConfirmation: '',
        currentPasswordError: '',
        newPasswordError: '',
        newPasswordConfirmationError: '',
        modalAlertMsg: '',
        modalAlertTitle: '',
        isAutoCompleteCurrentPass: false,
        isAutoCompleteNewPass: false,
        isAutoCompleteConfirmPass: false,
      });
    }
  }

  handleCurrentPassword(e) {
    this.setState({
      currentPassword: e.target.value,
      currentPasswordError: '',
    });
  }

  handleNewPassword(e) {
    this.setState({
      newPassword: e.target.value,
      newPasswordError: '',
    });
  }

  handleNewPasswordConfirmation(e) {
    this.setState({
      newPasswordConfirmation: e.target.value,
      newPasswordConfirmationError: '',
    });
  }

  handleConfirm(event) {
    if (event.key === 'Enter') {
      this.onSubmit();
    }
  }

  handleCloseAlert() {
    const { t } = this.props;
    const { modalAlertTitle } = this.state;

    if (modalAlertTitle === t('modal.title.attention')) {
      this.setState({
        modalAlert: false,
      });
    } else {
      this.setState(
        {
          modalAlert: false,
        },
        () => {
          this.closePasswordModal();
        }
      );
    }
  }

  handleCurrentFocus() {
    this.setState({
      isAutoCompleteCurrentPass: true,
    });
  }

  handleNewFocus() {
    this.setState({
      isAutoCompleteNewPass: true,
    });
  }

  handleConfirmFocus() {
    this.setState({
      isAutoCompleteConfirmPass: true,
    });
  }

  onSubmit(event) {
    const { t } = this.props;
    const { currentPassword, newPassword, newPasswordConfirmation } = this.state;
    if (event) {
      event.preventDefault();
    }
    if (!this.validateFields()) {
      return null;
    }
    this.setState({
      //isLoading: true,
      isLoader: true,
      modalAlert: true,
    });
    const data = {
      current_password: currentPassword,
      password: newPassword,
      password_confirmation: newPasswordConfirmation,
    };

    api
      .resetPasswordProfile(data)
      .then(() => {
        this.setState({
          isLoader: false,
          modalAlertMsg: t('modal.message.success_update_password'),
          modalAlertTitle: t('modal.title.notice'),
        });
      })
      .catch((err) => {
        const o = err.data.response;
        if (o.error === '422-011') {
          return this.setState({
            isLoader: false,
            modalAlertTitle: t('modal.title.attention'),
            modalAlertMsg: t('modal.error.incorrect_password'),
            currentPasswordError: t('modal.error.incorrect_password'),
          });
        }
        if (o.error_description) {
          this.setState({
            isLoader: false,
            modalAlertTitle: t('modal.title.attention'),
            modalAlertMsg: o.error_description,
          });
        } else {
          this.setState({
            isLoader: false,
            modalAlertTitle: t('modal.title.attention'),
            modalAlertMsg: t('modal.error.unknow_error'),
          });
        }
      });
  }

  closePasswordModal() {
    const { closeModal } = this.props;
    closeModal();
  }

  validateFields() {
    const { t } = this.props;
    const { currentPassword, newPassword, newPasswordConfirmation } = this.state;
    const validation = {
      currentPassword: true,
      newPassword: true,
      newPasswordConfirmation: true,
    };

    if (currentPassword.trim().length === 0) {
      this.setState({
        currentPasswordError: t('modal.error.empty_current_password'),
      });
      validation.currentPassword = false;
      return;
    }

    if (newPassword.trim().length === 0) {
      this.setState({
        newPasswordError: t('modal.error.empty_new_password'),
      });
      validation.newPassword = false;
      return;
    } if (!this.checkPassword(newPassword)) {
      this.setState({
        newPasswordError: t('modal.error.error_char_password'),
      });
      validation.newPassword = false;
      return;
    }
    validation.newPassword = true;

    if (newPassword !== newPasswordConfirmation) {
      this.setState({
        newPasswordConfirmationError: t('modal.error.error_match_confirm_password'),
      });
      validation.newPasswordConfirmationError = false;
      return;
    }
    validation.newPasswordConfirmationError = true;
    return (
      validation.currentPassword && validation.newPassword && validation.newPasswordConfirmation
    );
  }

  checkPassword(value) {
    let char_type = 0;
    if (/[A-Z]/.test(value) || /[a-z]/.test(value)) {
      char_type += 1;
    }
    if (/[0-9]/.test(value)) {
      char_type += 1;
    }
    if (/[~!@#$%^&*()_+`\-={}|[\]\\:";'<>?,./]/gi.test(value)) {
      char_type += 1;
    }
    return !(char_type < 3 || value.length < 8 || value.length > 72);
  }

  render() {
    const {
      isExpirationPass,
      isAutoCompleteCurrentPass,
      isAutoCompleteNewPass,
      isAutoCompleteConfirmPass,
      currentPasswordError,
      newPasswordError,
      newPasswordConfirmationError,
      isOpenMCP,
      currentPassword,
      newPassword,
      newPasswordConfirmation,
      modalAlert,
      isLoader,
      modalAlertTitle,
      modalAlertMsg,
    } = this.state;

    const { state, t } = this.props;

    const currentPasswordErrorClass = currentPasswordError !== '' ? 'show' : '';
    const newPasswordErrorClass = newPasswordError !== '' ? 'show' : '';
    const newPasswordConfirmationErrorClass = newPasswordConfirmationError !== '' ? 'show' : '';

    if (state.user.scanConfig.isLoading) {
      return <Loader />;
    }

    return (
      <Modal open={isOpenMCP} onClose={this.closePasswordModal}>
        <div className="profile_popup_wrap">
          <div className="profile_popup default_popup">
            <div className="profile_popup_header">
              <h2 className="popup_name">
                {
                  isExpirationPass ? t('modal.title.update_password') : t('modal.title.change_password')
                }
              </h2>
              <p className="small_text" style={{ marginTop: '10px' }}>
                {
                  isExpirationPass ? t('modal.message.update_password') : ''
                }
              </p>
            </div>
            <div className="profile_popup_contents">
              <div className="profile_popup_content_wrap">
                <div className="profile_popup_content">
                  <p className="label">
                    {t('modal.title.current_password')}
                    <em style={{ marginLeft: '0' }} className="asterisk" />
                  </p>
                  <p className="value">
                    {!currentPasswordError ? (
                      <input
                        type="password"
                        placeholder={t('modal.title.current_password')}
                        value={currentPassword}
                        onChange={this.handleCurrentPassword}
                        onFocus={this.handleCurrentFocus}
                        onKeyPress={this.handleConfirm}
                        readOnly={!isAutoCompleteCurrentPass}
                        //autoFocus
                      />
                    ) : (
                      <input
                        type="password"
                        placeholder={t('modal.title.current_password')}
                        value={currentPassword}
                        onChange={this.handleCurrentPassword}
                        onFocus={this.handleCurrentFocus}
                        onKeyPress={this.handleConfirm}
                        style={{ border: '1px solid rgb(239, 65, 54)' }}
                        readOnly={!isAutoCompleteCurrentPass}
                      />
                    )}
                    <div
                      className={`error ${currentPasswordErrorClass}`}
                      style={{
                        lineHeight: '20px',
                        marginLeft: '5px',
                        fontSize: '12px',
                        fontWeight: '700',
                        color: '#ef4136',
                      }}
                    >
                      {currentPasswordError}
                    </div>
                  </p>
                </div>
                <div className="profile_popup_content">
                  <p className="label">
                    {t('modal.title.new_password')}
                    <em style={{ marginLeft: '0' }} className="asterisk" />
                  </p>
                  <p className="value">
                    {!newPasswordError ? (
                      <input
                        type="password"
                        placeholder={t('modal.title.new_password')}
                        value={newPassword}
                        onChange={this.handleNewPassword}
                        onFocus={this.handleNewFocus}
                        onKeyPress={this.handleConfirm}
                        readOnly={!isAutoCompleteNewPass}
                      />
                    ) : (
                      <input
                        type="password"
                        placeholder={t('modal.title.new_password')}
                        value={newPassword}
                        onChange={this.handleNewPassword}
                        onFocus={this.handleNewFocus}
                        onKeyPress={this.handleConfirm}
                        readOnly={!isAutoCompleteNewPass}
                        style={{ border: '1px solid rgb(239, 65, 54)' }}
                      />
                    )}

                    <div
                      className={`error ${newPasswordErrorClass}`}
                      style={{
                        lineHeight: '20px',
                        marginLeft: '5px',
                        fontSize: '12px',
                        fontWeight: '700',
                        color: '#ef4136',
                      }}
                    >
                      {newPasswordError}
                    </div>
                  </p>
                </div>
                <div className="profile_popup_content">
                  <p className="label">
                    {t('modal.title.password_confirmation')}
                    <em style={{ marginLeft: '0' }} className="asterisk" />
                  </p>
                  <p className="value">
                    {!newPasswordConfirmationError ? (
                      <input
                        type="password"
                        placeholder={t('modal.title.confrim_password')}
                        value={newPasswordConfirmation}
                        onChange={this.handleNewPasswordConfirmation}
                        onFocus={this.handleConfirmFocus}
                        onKeyPress={this.handleConfirm}
                        readOnly={!isAutoCompleteConfirmPass}
                      />
                    ) : (
                      <input
                        type="password"
                        placeholder={t('modal.title.confrim_password')}
                        value={newPasswordConfirmation}
                        onChange={this.handleNewPasswordConfirmation}
                        onFocus={this.handlePWFocus}
                        onKeyPress={this.handleConfirmFocus}
                        readOnly={!isAutoCompleteConfirmPass}
                        style={{ border: '1px solid rgb(239, 65, 54)' }}
                      />
                    )}
                    <div
                      className={`error ${newPasswordConfirmationErrorClass}`}
                      style={{
                        lineHeight: '20px',
                        marginLeft: '5px',
                        fontSize: '12px',
                        fontWeight: '700',
                        color: '#ef4136',
                      }}
                    >
                      {newPasswordConfirmationError}
                    </div>
                  </p>
                </div>
              </div>
              <div className="profile_popup_button_wrap">
                <a
                  className="button cancel_button"
                  onClick={this.closePasswordModal}
                  onKeyUp={this.closePasswordModal}
                >
                  {t('modal.button.cancel')}
                </a>
                <a
                  className="button save_button"
                  onClick={this.onSubmit}
                  onKeyUp={this.onSubmit}
                >
                  {t('modal.button.save')}
                </a>
              </div>
            </div>
          </div>
        </div>
        <Modal open={modalAlert} onClose={this.handleCloseAlert}>
          {isLoader ? (
            <Loader />
          ) : (
            <div className="modal_popup_wrap confirm_wrap">
              <div className="modal_popup_box confirm_box">
                <div className="modal_popup confirm">
                  <h2 className="title">{modalAlertTitle}</h2>
                  <p className="text">{modalAlertMsg}</p>
                  <div className="button_wrap">
                    <a
                      className="center_button"
                      onClick={this.handleCloseAlert}
                      onKeyUp={this.handleCloseAlert}
                    >
                      {t('modal.button.ok')}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          )}
        </Modal>
      </Modal>
    );
  }
}

export default WithRouter(withTranslation()(inject('state')(observer(ChangePasswordModal))));
